/**
 * Michigan county catalogue.
 *
 * Source: U.S. Census Bureau, 2020 national county file
 * https://www2.census.gov/geo/docs/reference/codes2020/national_county2020.txt
 * filtered to STATE = MI.
 *
 * Michigan has 83 counties. Their FIPS codes run 26001–26165 in alphabetical
 * order, every odd number — the standard Census assignment. `26041` is Delta
 * and `26115` is Monroe; both are asserted in the catalogue tests as spot
 * checks against this source.
 *
 * Data only. See `shared/counties/index.ts` for the unified catalogue and the
 * derived constants; nothing outside that module should import this file.
 */

import type { CatalogueCounty } from './types.js';

export const MICHIGAN_COUNTIES: readonly CatalogueCounty[] = [
  { name: 'Alcona', state: 'MI', fips: '26001' },
  { name: 'Alger', state: 'MI', fips: '26003' },
  { name: 'Allegan', state: 'MI', fips: '26005' },
  { name: 'Alpena', state: 'MI', fips: '26007' },
  { name: 'Antrim', state: 'MI', fips: '26009' },
  { name: 'Arenac', state: 'MI', fips: '26011' },
  { name: 'Baraga', state: 'MI', fips: '26013' },
  { name: 'Barry', state: 'MI', fips: '26015' },
  { name: 'Bay', state: 'MI', fips: '26017' },
  { name: 'Benzie', state: 'MI', fips: '26019' },
  { name: 'Berrien', state: 'MI', fips: '26021' },
  { name: 'Branch', state: 'MI', fips: '26023' },
  { name: 'Calhoun', state: 'MI', fips: '26025' },
  { name: 'Cass', state: 'MI', fips: '26027' },
  { name: 'Charlevoix', state: 'MI', fips: '26029' },
  { name: 'Cheboygan', state: 'MI', fips: '26031' },
  { name: 'Chippewa', state: 'MI', fips: '26033' },
  { name: 'Clare', state: 'MI', fips: '26035' },
  { name: 'Clinton', state: 'MI', fips: '26037' },
  { name: 'Crawford', state: 'MI', fips: '26039' },
  { name: 'Delta', state: 'MI', fips: '26041' },
  { name: 'Dickinson', state: 'MI', fips: '26043' },
  { name: 'Eaton', state: 'MI', fips: '26045' },
  { name: 'Emmet', state: 'MI', fips: '26047' },
  { name: 'Genesee', state: 'MI', fips: '26049' },
  { name: 'Gladwin', state: 'MI', fips: '26051' },
  { name: 'Gogebic', state: 'MI', fips: '26053' },
  { name: 'Grand Traverse', state: 'MI', fips: '26055' },
  { name: 'Gratiot', state: 'MI', fips: '26057' },
  { name: 'Hillsdale', state: 'MI', fips: '26059' },
  { name: 'Houghton', state: 'MI', fips: '26061' },
  { name: 'Huron', state: 'MI', fips: '26063' },
  { name: 'Ingham', state: 'MI', fips: '26065' },
  { name: 'Ionia', state: 'MI', fips: '26067' },
  { name: 'Iosco', state: 'MI', fips: '26069' },
  { name: 'Iron', state: 'MI', fips: '26071' },
  { name: 'Isabella', state: 'MI', fips: '26073' },
  { name: 'Jackson', state: 'MI', fips: '26075' },
  { name: 'Kalamazoo', state: 'MI', fips: '26077' },
  { name: 'Kalkaska', state: 'MI', fips: '26079' },
  { name: 'Kent', state: 'MI', fips: '26081' },
  { name: 'Keweenaw', state: 'MI', fips: '26083' },
  { name: 'Lake', state: 'MI', fips: '26085' },
  { name: 'Lapeer', state: 'MI', fips: '26087' },
  { name: 'Leelanau', state: 'MI', fips: '26089' },
  { name: 'Lenawee', state: 'MI', fips: '26091' },
  { name: 'Livingston', state: 'MI', fips: '26093' },
  { name: 'Luce', state: 'MI', fips: '26095' },
  { name: 'Mackinac', state: 'MI', fips: '26097' },
  { name: 'Macomb', state: 'MI', fips: '26099' },
  { name: 'Manistee', state: 'MI', fips: '26101' },
  { name: 'Marquette', state: 'MI', fips: '26103' },
  { name: 'Mason', state: 'MI', fips: '26105' },
  { name: 'Mecosta', state: 'MI', fips: '26107' },
  { name: 'Menominee', state: 'MI', fips: '26109' },
  { name: 'Midland', state: 'MI', fips: '26111' },
  { name: 'Missaukee', state: 'MI', fips: '26113' },
  { name: 'Monroe', state: 'MI', fips: '26115' },
  { name: 'Montcalm', state: 'MI', fips: '26117' },
  { name: 'Montmorency', state: 'MI', fips: '26119' },
  { name: 'Muskegon', state: 'MI', fips: '26121' },
  { name: 'Newaygo', state: 'MI', fips: '26123' },
  { name: 'Oakland', state: 'MI', fips: '26125' },
  { name: 'Oceana', state: 'MI', fips: '26127' },
  { name: 'Ogemaw', state: 'MI', fips: '26129' },
  { name: 'Ontonagon', state: 'MI', fips: '26131' },
  { name: 'Osceola', state: 'MI', fips: '26133' },
  { name: 'Oscoda', state: 'MI', fips: '26135' },
  { name: 'Otsego', state: 'MI', fips: '26137' },
  { name: 'Ottawa', state: 'MI', fips: '26139' },
  { name: 'Presque Isle', state: 'MI', fips: '26141' },
  { name: 'Roscommon', state: 'MI', fips: '26143' },
  { name: 'Saginaw', state: 'MI', fips: '26145' },
  { name: 'St. Clair', state: 'MI', fips: '26147' },
  { name: 'St. Joseph', state: 'MI', fips: '26149' },
  { name: 'Sanilac', state: 'MI', fips: '26151' },
  { name: 'Schoolcraft', state: 'MI', fips: '26153' },
  { name: 'Shiawassee', state: 'MI', fips: '26155' },
  { name: 'Tuscola', state: 'MI', fips: '26157' },
  { name: 'Van Buren', state: 'MI', fips: '26159' },
  { name: 'Washtenaw', state: 'MI', fips: '26161' },
  { name: 'Wayne', state: 'MI', fips: '26163' },
  { name: 'Wexford', state: 'MI', fips: '26165' },
];
